<div class="d-flex align-items-center gap-2">
  <span class="d-flex align-items-center justify-content-center flex-shrink-0">
    <mat-icon svgIcon="{{meta().icon}}"></mat-icon>
  </span>

  <div class="flex-fill overflow-hidden">
    <div class="mat-font-label-sm text-uppercase fw-semibold">
      {{ meta().label }}
    </div>
    <div class="mat-font-label-sm text-truncate text-body-secondary">
      {{ secondaryText() }}
    </div>
  </div>

  @if (showChangeButton()) {
    <button matButton type="button" (click)="changeArea.emit()">
      Change
    </button>
  }
  @if (!showChangeButton() && this.area().geometryWkt) {
    <mat-icon class="icon-primary">check_circle</mat-icon>
  }
</div>
